module.exports = globalThis.bootstrap